import React from 'react';
import { useUploadLimits } from '../lib/uploadLimits';

// "<types>, max N MB" (types defaults to "PDF only") — N comes from backend config, not a literal.
export default function UploadHint({ className = 'text-xs text-slate-400 dark:text-slate-500', prefix = '', types = 'PDF only' }) {
  const { uploadMb } = useUploadLimits();
  return <span className={className}>{prefix}{types}, max {uploadMb} MB</span>;
}
